<template>
  <div>
    <b-modal
      id="modal-input"
      size="lg"
      centered
      title="Tambah Data Tunjangan"
      header-bg-variant="primary"
      header-text-variant="light"
    >
      <b-form>
        <b-form-group label=" Nama Tunjangan" label-cols-md="3">
          <b-form-input
            :state="checkIfValid('namaTunjangan')"
            v-model="$v.dataTunjangan.namaTunjangan.$model"
            @keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>
      </b-form>

      <b-form>
        <b-form-group label="Nominal Tunjangan" label-cols-md="3">
          <b-form-input
            type="number"
            :state="checkIfValid('nominalTunjangan')"
            v-model="$v.dataTunjangan.nominalTunjangan.$model"
            :placeholder="convert(dataTunjangan.nominalTunjangan)"
            @keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>
      </b-form>
      <!-- <b-form>
        <b-form-group label="Nominal Tunjangan" label-cols-md="3">
          <b-form-input
            :state="checkIfValid('nominalTunjangan')"
            v-model="$v.dataTunjangan.nominalTunjangan.$model"
            :placeholder="convert(dataTunjangan.nominalTunjangan)"
            @keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>
      </b-form> -->
      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="$bvModal.hide('modal-input')"
        >
          {{ $store.state.form.batal }}
        </b-button>
        <b-button variant="primary" @click="simpan()" :disabled="!isValid"
          >Simpan</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, numeric } from "vuelidate/lib/validators";

export default {
  name: "modalInput",
  props: ["kategori", "unit"],
  data() {
    return {
      dataTunjangan: {
        namaTunjangan: null,
        nominalTunjangan: null,
      },
      selected: null,
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.dataTunjangan, null, 4);
    },
    isValid() {
      return !this.$v.dataTunjangan.$invalid;
    },
    isDirty() {
      return this.$v.dataTunjangan.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    dataTunjangan: {
      namaTunjangan: {
        required,
      },
      nominalTunjangan: {
        required,
        numeric,
      },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.dataTunjangan[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    convert(x) {
      if (x) {
        return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
    simpan() {
      let vm = this;
      if (vm.isValid) {
        vm.busy = true;
        vm.button = "Mohon Tunggu";
        vm.$axios
          .post("masterTunjangan/register", vm.dataTunjangan)
          .then((res) => {
            if (res.data.message == "sukses") {
              vm.button = "Simpan";
              vm.busy = false;
              vm.$v.$reset();
              vm.$emit("alertFromChild", {
                variant: "success",
                msg: "BERHASIL MENDAFTARKAN MASTER TUNJANGAN",
                showing: true,
              });
              this.$bvModal.hide("modal-input");
              this.reset();
            } else {
              vm.button = "Simpan";
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "danger",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
            }
          })
          .catch((err) => {
            err;
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: "TERJADI KESALAHAN PADA SERVER",
              showing: true,
            });
          });
      }
    },
    reset() {
      this.$v.$reset();
      this.dataTunjangan = {
        namaTunjangan: "",
        nominalTunjangan: "",
      };
    },
  },
};
</script>
